import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { translate } from '@/utils/translations'

import TabNavItem from '../TabNavItem'
const NAV_KEY = 'table-of-contents'

const TableOfContentsNavItem = ({ handleOnClick }) => {
  const isOnlineResource = useSelector(state => state.asset.isOnlineResource)

  return(
    <TabNavItem
      condition={!isOnlineResource}
      eventKey={NAV_KEY}
      setEventKey={handleOnClick}
      title={translate('common.table_of_contents')}
    />
  )
}

export default TableOfContentsNavItem

TableOfContentsNavItem.propTypes = {
  handleOnClick: PropTypes.func.isRequired
}
